import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

interface Props {
  isEdit: boolean
  onSubmit: () => Promise<void>
}
export const StowageInstructionFormHeader = observer(({ isEdit, onSubmit }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action =
    (isEdit ? t('edit', 'Edit') : t('addNew', 'Add new')) +
    ' ' +
    t('stowageInstruction', 'stowage instruction')

  const breadCrumbs: BreadcrumpItem[] = useMemo(() => {
    return [
      { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
      {
        label: t('stowageInstructions', 'Stowage Instructions'),
        route: PATHS.masterData.stowageInstruction.url,
      },
      {
        label: action,
      },
    ]
  }, [t, action, navigate])

  return (
    <Header
      title={action}
      breadcrumbs={breadCrumbs}
      position='relative'
      rightRenderOption={
        <>
          <Button
            variant='text'
            color='inherit'
            data-cy='cancel-stowage-instruction-btn'
            onClick={() => navigate(PATHS.masterData.stowageInstruction.url)}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => onSubmit()}
            data-cy='stowage-instruction-save-btn'
          >
            {t('submit', 'Submit')}
          </Button>
        </>
      }
    />
  )
})
